import classNames from 'classnames';
import { FC } from 'react';
import FinancialNavArrowIcon from '../icons/FinancialNavArrowIcon';

interface IProps {
  onPrev: () => void;
  onNext: () => void;
  currentPageNumber: number;
  pagesCount: number;
}

const FinancialNavigationBtns: FC<IProps> = ({
  children,
  onPrev,
  onNext,
  currentPageNumber,
  pagesCount,
}) => {
  return (
    <div className="financial-results__navigation--container">
      <div
        className={classNames(
          'financial-results__navigation--btn financial-results__navigation--btn__left',
          {
            'financial-results__navigation--btn__disabled':
              currentPageNumber === 0,
          },
        )}
        onClick={onPrev}
      >
        <FinancialNavArrowIcon />
      </div>
      {children}

      <div
        className={classNames(
          'financial-results__navigation--btn financial-results__navigation--btn__right',
          {
            'financial-results__navigation--btn__disabled':
              currentPageNumber === pagesCount - 1,
          },
        )}
        onClick={onNext}
      >
        <FinancialNavArrowIcon />
      </div>
    </div>
  );
};

export default FinancialNavigationBtns;
